export const storefrontClient = async (
  query: string,
  variables?: unknown
) => {
  const response = await fetch(
    'https://reggioregister.myshopify.com/api/2024-10/graphql.json',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'ec279d213070e4ba51b23c01a90602a6'
      },
      body: JSON.stringify({ query, variables })
    }
  )

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const data = await response.json()
  return data
}
